export const thumbnailImagesFormatter = (images: string): string[] => {
  const parsed = JSON.parse(images)
  const formattedImages = []
  for (const key in parsed) {
    formattedImages.push(parsed[key])
  }
  return formattedImages
}
